export * from './ecall-pdf-summary.component';


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-pdf-summary/index.ts